type SearchableScreen = {
  id: string;
  searchText?: string;
  subtitle: string;
  title: string;
};

/** Whether any of the search values appears in the screen name, address (subtitle), device id / ad exchange or id. */
export const matchesScreenSearch = (
  { id, searchText = '', subtitle, title }: SearchableScreen,
  searchValues: string[]
): boolean => {
  const searchableText = [title, subtitle, searchText, id].join(' ').toLowerCase();
  return searchValues.some(search => searchableText.includes(search.toLowerCase()));
};
